import React from 'react'
import styled from 'styled-components'
import { FaThList } from 'react-icons/fa';
import ProjectItem from './ProjectItem';


// {
//   name: "E-commmoneysaver",
//   link: "/assets/projects/e-comm.png",
//   URI: "https://e-commmoneysaver.netlify.app/"
// },

export default function Project() {
  const projectList = [
    {
      name: "Ping Pong Game",
      link: "/assets/projects/pingponggame.gif",
      URI: "https://bhushan-verma-pingponggame.netlify.app/"
    },
    {
      name: "Handy Notebook",
      link: "/assets/projects/handynotebook.png",
      URI: "https://handynotebookbybhushan.netlify.app/"
    },
    {
      name: "Alarm Clock",
      link: "/assets/projects/alarmClock.png",
      URI: "https://bhushanverma1998.github.io/AlarmClock/"
    },
    {
      name: "Music Player",
      link: "/assets/projects/music-app.png",
      URI: "https://bhushanverma1998.github.io/music-player/"
    },
    {
      name: "Todo App",
      link: "/assets/projects/todoApp.png",
      URI: "https://todo-app-4nqm.onrender.com"
    },
    {
      name: "Calculator",
      link:"/assets/projects/calculator.png",
      URI:"https://bhushanverma1998.github.io/calculator/"
    },
    {
      name:"MovieWala App",
      link:"/assets/projects/movieWala.png",
      URI:"https://movie-wala.netlify.app/"
    }
  ]
  return (
    <Wrapper id="project">
      <h3 className="section-heading">
        <span><FaThList /></span>
        <span>Projects</span>
      </h3>
      <div className="project-display">
        {
          projectList.map((elem) => {

            return <div className='project-container'> <ProjectItem data={elem} />
            </div>
          })
        }
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
margin: 40px auto;

.section-heading {
    width: auto;
    padding: 20px 10px 10px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
}

.section-heading span {
    font-size: 40px;
    color: var(--section-color);
    padding-top: 10px;
    margin-right: .5rem;
    display: flex;
    align-items: center;
}

.project-display {
  display: flex;
  width: 80%;
  flex-wrap: wrap;
  gap: 2rem;
  padding-bottom: 3rem;
  justify-content: space-around;

  .project-container{
    position: relative;
    &:hover{
      img{
        box-shadow: 0px 0px 5px 2px var(--section-color);
        filter: blur(2px);
      }
      .project-details{
        display:flex;
        justify-content: center;
        align-items: center;
      }
    }

    .project-details{
      position: absolute;
      top:0;
      left:0;
      right:0;
      bottom:0;
      z-index:1;
      display: none;
      text-decoration: none;
      button{
        cursor: pointer;
        height: 3rem;
        width: 8rem;
        box-shadow: 0px 0px 3px 2px var(--section-color);
        background-color: #1d1c21;
        border-radius: 15px;
        color: white;
        
      }
    }

  img {
    width: 20rem;
    padding: 1rem;
    border-radius: 1rem;
    transition: all .3s ease-in-out;
  }
}
`